<template>
    <div class="body">
        
        <!-- <h2 style="text-align: center;">质询电话:123456789</h2> -->
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
     
        <el-dialog      text-align="center"
                :close-on-click-modal="false"
                class="pay-dialog"
                width="500px"
                center
                :visible.sync="dialogVisible">
            <div class="dialogPrice">支付：<span class="prices" style="color:red;">{{ totalPrice }}元</span></div>
            <div class="codeimg">
                <img v-if="imageData" :src="imageData" />
            </div>
            <div class="alert">请您及时付款，已便订单尽快处理！</div>
            <div class="finish">
                <div class="error">支付遇到问题</div>
                <div class="success">我已支付</div>
            </div>
        </el-dialog>
        <div class="accountForm-header">
        <el-row :gutter="24">
                            <el-col :span="13">
                                <el-form-item label="充值账号">
                                    <el-input
                                        class="input-name"
                                   
                                        v-model="accountForm.access"
                                        placeholder="请输入产品种类"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
        
   
   

                                <el-form-item label="充值类型:"  >
                      <el-select clearable  v-model.trim="accountForm.type" @change="getType()" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in type"
                                    clearable
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                    </el-form-item>

                                <el-form-item label="类型详情:"  >
                      <el-select clearable  v-model="accountForm.id"  @change="getImage"
                                ref="optionRef"      >
                                <el-option
                                    v-for="item in goodsInfo"
                                    clearable
                                    :key="item.amount"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                    </el-form-item>

                                    
        </div>
        </el-form>

     
    </div>
  </template>
  
  <script>
  import {selectRechargeGoods,native,queryOrder} from '@/api/set/recharge.js'
  export default {
    data() {
      return {
        imageData:'',
        totalPrice:'',
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        date: '',
        conTract: [],
        CollageSetFindDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            productionProcesses:''
        },
        goodsInfo:[],
        ncProgramme:[],
        type:[{
        value: 'RECHG',
        label: '积分充值'
      },{
        value: 'JFRHGB',
        label: '积分充值卡'
      },{
        value: 'HYRHGB',
        label: '会员充值卡'
      }],
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          orderNo:'',
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }

      }
    },
    
  
    mounted() {
      this.accountForm.access=localStorage.getItem("access")
 // 进入页面调用一次获取数据的方法
    },  
    methods: {
        getType(){
            selectRechargeGoods(this.accountForm.type).then((res) => {
            this.goodsInfo=[];
          for(let i=0;i<res.data.data.length;i++){
        //   this.goodsInfo[i].value = res.data.data[i].id
        //      this.goodsInfo[i].label=res.data.data[i].amount+"元"+res.data.data[i].points+"积分"
        if(this.accountForm.type==='RECHG'){
            this.goodsInfo.push({label:res.data.data[i].amount/100+"元"+res.data.data[i].points+"积分",value: res.data.data[i].id,amount: res.data.data[i].amount/100})
        }else if(this.accountForm.type==='JFRHGB'){
            this.goodsInfo.push({label:res.data.data[i].amount/100+"元"+res.data.data[i].num+'张'+res.data.data[i].points+"积分充值卡",value: res.data.data[i].id,amount: res.data.data[i].amount/100})
        }else if(this.accountForm.type==='HYRHGB'){
            this.goodsInfo.push({label:res.data.data[i].amount/100+"元"+res.data.data[i].num+'张'+res.data.data[i].level+"会员充值卡",value: res.data.data[i].id,amount: res.data.data[i].amount/100})
        }
             
            }
       
        })
        },
        getImage(val){
            native(this.accountForm).then((res)=>{
                if(res.data.data){
                    console.log(res.data.data)
                this.totalPrice=res.data.data.amount
                this.imageData=res.data.data.imageBase64
                queryOrder(res.data.data.orderNo).then((res)=>{
                    if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '充值成功!!!',
              }),
              this.imageData=''
              this.totalPrice=''
              this.accountForm.type=''
              this.accountForm.id=''
              this.dialogVisible=false;
            } 
            } })
            .catch((error) => {
                this.$message({
                type: 'success',
                message:'超时!!!' 
              })
              this.imageData=''
              this.totalPrice=''
              this.accountForm.type=''
              this.accountForm.id=''
              this.dialogVisible=false;
          })
                }
            })
            this.dialogVisible=true;
        }
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination ::v-deep.el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .table-label{
      color: var(--secondColor);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  ::v-deep.table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  ::v-deep.table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  ::v-deep.order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  ::v-deep.dialog-upload{
      display: flex;
  }
  ::v-deep.dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  ::v-deep.dialog-upload .el-form-item__content{
      justify-content: right;
  }
  ::v-deep.dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  ::v-deep.dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  ::v-deep.dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  ::v-deep.el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }
  >>>.el-dialog {
    text-align: center !important;
    border-radius: 10px!important;
}
  </style>
  